import { ReactNode } from 'react';
import clsx from 'clsx';
import styles from './Heading.module.css';

export enum HeadingType {
    A = 'a',
    B = 'b',
    C = 'c',
}

interface HeadingProps {
    level?: 2 | 3 | 4 | 5 | 6;
    type?: HeadingType;
    text: string;
    subText?: string;
    className?: string;
    id?: string;
}

interface HeadingElementProps {
    level: number;
    children?: ReactNode;
    style?: string;
}

export const Heading = (props: HeadingProps) => {
    const {type = HeadingType.A, level = 6, text, subText, className, id} = props;
    // MEMO: マイページではlevel3のスタイル使わないで次のレベルのスタイルを使う
    const styleLevel = level > 3 ? level + 1 : level;
    const elementStyles = clsx(styles[`mod-hdg-${type}l${styleLevel}`], className);

    return (
        <div className={elementStyles} id={id}>
            <HeadingElement level={level ? level : 6}>
                {type === HeadingType.A && subText && level === 2 ? (
                    <>
                        <span>{subText}</span>
                        <strong>{text}</strong>
                    </>
                ) : (
                    text
                )}
            </HeadingElement>
            {type === HeadingType.B && subText && (
                <p>
                    <b className={styles['lede']}>{subText}</b>
                </p>
            )}
        </div>
    );
};

const HeadingElement = (props: HeadingElementProps) => {
    const {level, style, children} = props;

    if (level === 2) {
        return <h2 className={style}>{children}</h2>;
    }

    if (level === 3) {
        return <h3 className={style}>{children}</h3>;
    }

    if (level === 4) {
        return <h4 className={style}>{children}</h4>;
    }

    if (level === 5) {
        return <h5 className={style}>{children}</h5>;
    }

    return <h6 className={style}>{children}</h6>;
};
